import { render } from "./loveCompany.vue?vue&type=template&id=23fa8d4a"
import script from "./loveCompany.vue?vue&type=script&lang=js"
export * from "./loveCompany.vue?vue&type=script&lang=js"

import "./loveCompany.vue?vue&type=style&index=0&id=23fa8d4a&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__